import { render } from "./Home.vue?vue&type=template&id=59449eba"
const script = {}

import exportComponent from "C:\\Users\\Dominika\\Documents\\programowanie\\stonki\\nidomika.github.io\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__